import * as constants from '../constants';

const INITIAL_STATE = {
    status: 'disconnected',
};

export default function(state = INITIAL_STATE, action) {
    switch (action.type) {
        case constants.WS_CONNECTED:
            return Object.assign({}, state, {status: constants.CONNECTION_STATUS_CONNECTED});
        case constants.WS_CONNECTING:
            return Object.assign({}, state, {status: constants.CONNECTION_STATUS_CONNECTING});
        case constants.WS_DISCONNECTED:
            return Object.assign({}, state, {status: constants.CONNECTION_STATUS_DISCONNECTED});
    }
    return state;
}
